import * as actionType from "../constants/index";
export const clearBoardData = () => (dispatch) => {
  dispatch({ type: actionType.RESET_BOARDS });
  dispatch({ type: actionType.CLEAR_NOTE });
};
